export function getLocaleForNumberFormatting(locale) {
  switch (locale) {
    case 'de-AT':
      return 'de-DE';
    default:
      return locale;
  }
}